import Icon from '../components/Icon.vue'

Icon.register({
  bookmark: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M0 512v-464c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v464l-192-112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bookmark.js
// module id = 679
// module chunks = 0